import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-form-layout',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './admin-form-layout.component.html',
  styleUrl: './admin-form-layout.component.scss',
})
export class AdminFormLayoutComponent {
  @Input() titleKey = '';
  @Input() descriptionKey = '';
  @Input() compact = false;
}
